module.exports = __webpack_public_path__ + "img/10_51.506fd0c4.png";